import { NgModule, InjectionToken } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PaginaMantenimientoComponent } from '../shared/pagina-mantenimiento/pagina-mantenimiento.component';

const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');
const deactivateGuard = new InjectionToken('deactivateGuard');

const routes: Routes = [  
  { path: 'externalRedirect', canActivate: [externalUrlProvider], component: HomeComponent },
  { path: 'mantenimiento', redirectTo: '', component: PaginaMantenimientoComponent },
  { path: '404', redirectTo: '', component: PaginaMantenimientoComponent },
  { path: '**', redirectTo: '', component: PaginaMantenimientoComponent },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: externalUrlProvider,
      useValue: (route: ActivatedRouteSnapshot) => {
        const externalUrl = route.paramMap.get('externalUrl');
        window.open(externalUrl, '_self');
      },
    },
    {
      provide: deactivateGuard,
      useValue: () => {
        return false;
      }
    },
  ],
})


export class HomeRoutingModule { }
